import axiosPost from "./axiosPost";

export const RNHNivelUpd = async (credentials, data) => {
    const body = {
        service: "RNHNivelUpd",
        params: {
            rnhNivelId: data?.id,
            rnhNivelCod: data?.cod,
            rnhNivelNombre: data?.name,
            rnhNivelVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
